import { useEffect, useState } from 'react';
import { getActiveSponsoredPlacements, type PublicSponsoredPlacement } from '../repositories/sponsoredPlacementRepository';

/** The active sponsored placements Home shows above its stories; none until they load, or if the read fails. */
export function useSponsoredPlacements(): PublicSponsoredPlacement[] {
  const [placements, setPlacements] = useState<PublicSponsoredPlacement[]>([]);
  useEffect(() => {
    let disposed = false;
    void getActiveSponsoredPlacements().then(data => { if (!disposed) setPlacements(data); }).catch(() => {});
    return () => { disposed = true; };
  }, []);
  return placements;
}
